import imgOutside from '../../assetsFr/buildings/apartment/outside.jpg';
import imgWaterFr from "../../assetsFr/buildings/apartment/waterFr.jpg";
import imgWasteWater from '../../assetsFr/buildings/apartment/waste-water.jpg';
import imgHeating from '../../assetsFr/buildings/apartment/heating.jpg';
import imgFireProtection from '../../assetsFr/buildings/apartment/fire-protection.jpg';
import { Building, BuildingTechSectors } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';

const frenchWater: BuildingTechSectors = {
            type: TechSector.WATER,
            img: imgWaterFr,
            products: [
                {
                    position: {x: 90, y: 565},
                    type: ProductType.MULTI_ECO
                },
                {
                    position: {x: 425, y: 730},
                    type: ProductType.HYA_RAIN_N
                },
                {
                    position: {x: 637, y: 790},
                    type: ProductType.DELTA_BASIC_COMPACT_MVP
                },
                {
                    position: {x: 1018, y: 752},
                    type: ProductType.SISTO_16_RGAMAXX
                },
            ]
        }

const apartmentConfig: Building = {
    techSectors: [
        {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                    position: {x: 268, y: 880},
                    type: ProductType.BOAX_S_SF
                },
                {
                    position: {x: 420, y: 910},
                    type: ProductType.ETANORM
                },
                {
                    position: {x: 350, y: 855},
                    type: ProductType.SERIE_2000
                },
                {
                    position: {x: 560, y: 810},
                    type: ProductType.BOA_CONTROL_IMS
                },
                {
                    position: {x: 682, y: 800},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                    position: {x: 980, y: 800},
                    type: ProductType.CALIO_PRO_PLUS_Z
                },
                {
                    position: {x: 1112, y: 780},
                    type: ProductType.CALIO_PRO_PLUS
                },
                {
                    position: {x: 1180, y: 740},
                    type: ProductType.BOA_CONTROL_DPR
                },
                {
                    position: {x: 490, y: 300},
                    type: ProductType.BOA_CONTROL_PIC
                },
                {
                    position: {x: 1235, y: 715},
                    type: ProductType.BOA_CONTROL_SBV
                },
                {
                    position: {x: 1333, y: 745},
                    type: ProductType.BOA_RVK
                },
                {
                    position: {x: 1430, y: 760},
                    type: ProductType.ETALINE_Z
                },
            ]
        },
        frenchWater,
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                    position: {x: 1302, y: 749},
                    type: ProductType.MINI_COMPACTA
                },
                {
                    position: {x: 1517, y: 721},
                    type: ProductType.COMPACTA
                },
                {
                    position: {x: 1854, y: 667},
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR
                },
                {
                    position: {x: 353, y: 820},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                    position: {x: 777, y: 612},
                    type: ProductType.LEVELCONTROL_BASIC_2
                }
            ]
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                    position: {x: 965, y: 833},
                    type: ProductType.HYADUO_2_D_FL_COMPACT
                },
            ]
        }
    ],
    img: imgOutside
}

export default apartmentConfig;
